(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  /* ===== SLYCE ANNOUNCEMENT BAR - rotacao + hide on scroll ===== */
  (function() {
    const announcement = document.getElementById('SlyceAnnouncement');
    const sectionHeader = document.querySelector('.section-header');

    /* Detecta se o menu mobile esta aberto (classe que o tema adiciona no body) */
    function isMenuOpen() {
      const body = document.body;
      return body.classList.contains('overflow-hidden-mobile')
          || body.classList.contains('overflow-hidden-tablet')
          || body.classList.contains('overflow-hidden')
          || body.classList.contains('menu-open');
    }

    /* --- Calcula e seta os offsets globais (announcement + header) --- */
    function updateOffsets() {
      const announcementHiddenByScroll = announcement && announcement.classList.contains('is-hidden');
      const announcementHiddenByMenu = isMenuOpen();
      const announcementVisible = announcement && !announcementHiddenByScroll && !announcementHiddenByMenu;

      const announcementHeight = announcementVisible
        ? announcement.offsetHeight
        : 0;
      const headerHeight = sectionHeader ? sectionHeader.offsetHeight : 0;

      document.documentElement.style.setProperty(
        '--slyce-announcement-offset',
        `${announcementHeight}px`
      );
      document.documentElement.style.setProperty(
        '--slyce-total-offset',
        `${announcementHeight + headerHeight}px`
      );
      document.documentElement.style.setProperty(
        '--header-height',
        `${headerHeight}px`
      );
    }

    /* Init offsets */
    updateOffsets();
    window.addEventListener('resize', updateOffsets, { passive: true });

    /* Observa mudancas de classe no <body> pra detectar menu abrindo/fechando */
    if (window.MutationObserver) {
      const bodyObserver = new MutationObserver(updateOffsets);
      bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (!announcement) return;

    /* --- Rotacao entre frases (so se houver mais de 1) --- */
    const slides = announcement.querySelectorAll('.slyce-announcement__slide');
    if (slides.length > 1) {
      const rotationSeconds = parseFloat(announcement.dataset.rotationSpeed) || 4;
      let currentIndex = 0;
      setInterval(function() {
        slides[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % slides.length;
        slides[currentIndex].classList.add('is-active');
      }, rotationSeconds * 1000);
    }

    /* --- Hide on scroll: some assim que sai do topo, volta no topo --- */
    function handleAnnouncementScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isHidden = announcement.classList.contains('is-hidden');

      if (scrollTop > 0 && !isHidden) {
        announcement.classList.add('is-hidden');
        updateOffsets();
      } else if (scrollTop === 0 && isHidden) {
        announcement.classList.remove('is-hidden');
        updateOffsets();
      }
    }

    window.addEventListener('scroll', handleAnnouncementScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
